<template>
<div class="tv">
  <v-expand-transition>
    <v-list two-line class="pa-0" v-show="hasReply">
      <v-list-tile class="pa-0">
        <v-list-tile-avatar>
          <v-icon style="color: var(--v-accent-darken1) !important;">reply</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{replyText}}</v-list-tile-title>
          <v-list-tile-sub-title>{{replyTo}}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-list-tile-action-text>
            <v-icon medium @click="closeReply" style="padding-right:8px;">close</v-icon>
          </v-list-tile-action-text>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-expand-transition>

  <v-layout row id="tv">
    <emoji-picker class="tv__emoji" :callback="emojiSelected" />

    <v-flex>
      <div class="v-input tv__textarea v-textarea v-textarea--auto-grow v-textarea--no-resize v-text-field v-text-field--full-width v-text-field--enclosed v-input--hide-details">
        <div class="v-input__control">
          <div class="v-input__slot">
            <div class="v-text-field__slot">
              <div 
                id="typing-area"
                class="selectable-text"
                :placeholder="$t('chat_prompt_hint')" 
                contenteditable="true" 
                ref="input"
                @keydown="onKeyDown"
                @keyup="onKeyUp"
                @paste="onPaste"
                @focusout="onFocusOut"
              >{{draft}}</div>

            </div>
          </div>
        </div>
      </div>
    </v-flex>

    <div top offset-y right v-if="hasText">
      <v-icon medium class="tv__attachment" @click="sendMessage">send</v-icon>
    </div>

    <v-menu top offset-y right v-else>
      <v-icon medium class="tv__attachment" slot="activator">attach_file</v-icon>

      <v-list>
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          @click="openFileDialog(index)"
        >
          <v-icon style="padding-right: 12px;">{{item.icon}}</v-icon>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>

    <input type="file" id="files" name="files[]" multiple style="display:none;" :accept="fileFilter" />
  </v-layout>
</div>
</template>

<style lang="scss">
  .tv {
    margin:12px 42px 18px 42px;
    background-color:var(--v-baseBackground-base);
    border-radius: 6px;

    .v-list {
      border-radius: 6px;
    }
    .v-list__tile {
      border-radius: 6px !important;
      padding:0 !important;
      background-color:var(--v-baseBackground-base) !important;
    }
    .v-list__tile__avatar {
      min-width: 46px;
      margin-left: 2px;
    }
  }
  #tv {
    height: 100%;
    padding-top: 6px;

    .v-text-field.v-text-field--full-width .v-input__control {
      padding: 0 !important;
    }
    .v-input__slot {
      min-height:fit-content !important;
    }
    textarea:first-letter {
      text-transform: capitalize;
    }

    div[contenteditable=true] {
      flex: 1 1 auto;
      line-height: 18px;
      max-width: 100%;
      min-height: 32px;
      max-height: 123px; /* min-height + 5 * line-height + 1 */
      outline: none;
      padding: 7px 0 8px;
      width: 100%;
      overflow: hidden;
      padding-right: 12px;
      word-wrap: break-word;
      word-break: break-all;
      box-sizing: border-box;
    }

    [contenteditable=true]:empty:before{
      content: attr(placeholder);
      color: var(--secondary-text);
      display: block; /* For Firefox */
    }

    .emoji {
      max-width:18px !important;
      max-height:18px !important;
      display: inline-block;
      vertical-align:middle;
      position:relative;
      top:-2px;
    }

    .tv__emoji {
      padding-left:8px;
    }
    .tv__attachment {
      padding-right:8px;
    }
  }

  .ep-categories {
    background-color:var(--v-baseBackground-base) !important;
  }
  .ep-emojies {
    background-color:var(--v-additionalBackground-base) !important;
  }
</style>

<script>
  import imageUtils from '@utils/imageUtils'
  import { EventBus } from '@/event-bus'
  import ChatExtra  from '@/chatextra'
  ///import autosize from '@plugins/autosize'
  import EmojiPicker from '@dialogs/EmojiPicker.vue'

  const IMAGE = 0
  const FILE = 1
  const VIDEO = 2

  // TODO: move to utils
  function pasteHtmlAtCaret(html) {
    var sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
     
      var range = sel.getRangeAt(0);
      range.deleteContents();

      // Range.createContextualFragment() would be useful here but is
      // non-standard and not supported in all browsers (IE9, for one)
      var el = document.createElement("div");
      el.innerHTML = html;

      var frag = document.createDocumentFragment(), node, lastNode;
      while ( (node = el.firstChild) ) {
        lastNode = frag.appendChild(node);
      }
      range.insertNode(frag);
      
      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  }

  export default {
    name: 'typing-view',
    data () {
      return {        
        items: [
          { title: this.$t('chat_menu_picture'), icon: 'image' },
          { title: this.$t('chat_menu_document'), icon: 'insert_drive_file'  },
          { title: this.$t('chat_menu_video'), icon: 'video_library'  },
          //{ title: this.$t('chat_menu_contacts_book'), icon: 'person'  },
        ],
        draft: '',
        typingInProgress: false,
        selected: null,
        hasText: false,
        hasReply: false,
        replyTo: '',
        replyText: '',
        replyId: 0,
        fileFilter: '',
        attachment: FILE,
      }
    },
    components: {
      EmojiPicker
    },
    mounted() {
      this.$nextTick(() => {
        //autosize(this.$refs.input)
      })
      EventBus.$on('reply-message', this.onReply)

      document.getElementById('files').addEventListener('change', (ev) => {
        let files = ev.target.files
        if (files)
          this.attachSelectedFiles(files)
      }, false)
    },
    beforeDestroy() {
      EventBus.$off('reply-message')
    },
    methods: {
      sendMessage() {
        if (this.typingInProgress) {
          this.typingInProgress = false
          this.$store.dispatch('sendChatTyping', false)
        }

        let message = this.getText(this.$refs.input)
        if (message !== '') {
          let extra = new ChatExtra()
          if (this.hasReply)
            extra.setReplyId(this.replyId)
          this.closeReply()

          this.$store.dispatch('sendMessage', { 
            content: message, 
            type: this.types.TextMessage,
            extra: extra
          })
        }

        this.$nextTick(() => {
          const ta = this.$refs.input
          ta.innerText = ''
          this.hasText = false
          //autosize.update(ta)
        })
      },
      sendTyping() {
        if (!this.typingInProgress) {
          this.typingInProgress = true
          this.$store.dispatch('sendChatTyping', true)
          setTimeout(() => { 
            this.typingInProgress = false
            this.$store.dispatch('sendChatTyping', false)
          }, 4000)
        }
      },
      openFileDialog(index) {
        switch (index) {
          case IMAGE: 
            this.fileFilter = 'image/jpeg,image/png,image/gif'
            break
          case FILE:
            this.fileFilter = ''
            break
          case VIDEO:  
            this.fileFilter = 'video/mp4'
            break
          default:
            return
        }

        this.attachment = index

        let loader = document.getElementById('files')
        this.$nextTick(() => loader.click())
      },
      attachSelectedFiles(files) {
        switch (this.attachment) {
          case IMAGE: 
            this.$store.dispatch('sendAsImage', files)
            break
          case FILE:
            this.$store.dispatch('sendAsDocument', files)
            break
          case VIDEO:
            this.$store.dispatch('sendVideos', files)
            /*var files = fileSelector.openVideos(this)
            if (files) {
              files.forEach(fileName => {
                var extension = "." + fileName.split('.').pop()
                var newName = this.generateFileName(fileName)
                var localFile = EventBus.getUserFolderPath() + newName + extension
                console.log('-- localFile: ' + localFile)
                var localThumbnail = EventBus.getUserFolderPath() + newName  + ".JPG"
                console.log('-- localThumbnail: ' + localThumbnail)
                fileUtils.copyAttach(fileName, localFile).then(() => {
                  imageUtils.getVideoThumbnail(localFile, localThumbnail).then(result => {
                    var thumbnailToSend = EventBus.getUserFolderPath() + newName + extension + ".thumb"
                    var fs = require('fs')
                    fs.renameSync(localThumbnail, thumbnailToSend)

                    var videoExtra = new ChatExtra()
                    this.$store.dispatch("sendFile", { 
                      filePath: localFile,
                      thumbPath: thumbnailToSend, 
                      type: this.types.VideoMessage, 
                      extra: videoExtra
                    })
                  }).catch(error => {
                      console.log('Thumbnail generation failed for video:' + localFile)
                  })
                })
              })     
            }*/
            break
        }
      },
      onKeyDown(e) {
        if (e.keyCode === 13 && !e.shiftKey) {
          e.preventDefault()
          if (e.target.innerHTML !== '')
            this.sendMessage()
        } else {
          this.sendTyping()
        }
      },
      onKeyUp(e) {
        this.hasText = this.getText(e.target).trim() != ''
      },
      onPaste(e) {
        //console.log(e.clipboardData)
        if (e.clipboardData.files.length > 0) {
          let message = this.getText(this.$refs.input)
          if (message !== '')
            return

          this.$store.dispatch('pasteImage').then(filepath => {
            if (!filepath)
              return
            this.sendImages([filepath], (filename) => {
              fileUtils.removeFile(filename)
            })
          })
        } else {
          e.preventDefault()
          this.$store.dispatch('pasteText').then((text) => {
            pasteHtmlAtCaret(text)
          })
        }
      },
      onFocusOut(e) {
        let sel = document.getSelection()
        this.selected = sel.rangeCount > 0 ? sel.getRangeAt(0) : null
      },
      onReply(message) {
        console.log('--- reply: ' + JSON.stringify(message))

        this.replyText = message.content
        switch (message.type) {
          case this.types.DocumentMessage:
            this.replyText = message.data.name 
            break     
          case this.types.AudioMessage:
            this.replyText = this.$t('media_type_audio')
            break
          case this.types.ImageMessage:
            this.replyText = this.$t('chat_menu_picture')
            break
          case this.types.VideoMessage:
            this.replyText = this.$t('chat_menu_video')
            break            
        }

        this.replyTo = (!message.sent) ? message.authorName : this.$t('image_preview_your_image')
        this.replyId = message.id
        this.hasReply = true

        this.$refs.input.focus()
      },
      closeReply() {
        this.hasReply = false
        this.replyTo = ''
        this.replyText = ''
        this.replyId = 0  
        this.$refs.input.focus()
      },
      emojiSelected(e) {
        const unicode = String.fromCodePoint(parseInt(e.unified, 16))
        
        let imageHtml = this.replaceUnified(unicode)

        
        let ta = document.getElementById('typing-area')
        ta.focus()
        // restore caret
        let sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(this.selected)
        this.selected = null

        pasteHtmlAtCaret(imageHtml)
      },
      getText(ta) {
        let text = ''
        ta.childNodes.forEach(el => {
          if (el.nodeName == 'IMG') {
            text += String.fromCodePoint(parseInt(el.dataset.codepoints, 16))
          } else if (el.nodeName == 'BR') {
            text += '\n'
          } else {
            text += el.textContent
          }
        })
        return text.trim()
      },
      restoreDraft(chatId) {
        this.$store.dispatch('restoreDraft', chatId).then(draft => {
          if (draft !== '') {
            // TODO: replace emojis?
            console.log('-- draft restored', chatId, draft)
            this.$refs.input.innerHTML = this.replaceUnified(draft).replace('\n', '<br />')
            //autosize.update(this.$refs.input)
            this.draft = draft
            this.hasText = draft !== ''
          }
          // set typing area active for user input
          this.$refs.input.focus()
        })
      },
      storeDraft(chatId) {
        let message = this.getText(this.$refs.input)
        if (this.draft !== '' || message !== '') {
          this.$store.dispatch('storeDraft', { chatId: chatId, draft: message })
          this.$refs.input.innerHTML = ''
          //autosize.update(this.$refs.input)
        }
      }
    }
  }
</script>